import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { string, func } from 'prop-types'
import CloseCyclorama from './CloseCyclorama'
import { cycloramaLoading } from '../../store/Actions/CycloramaActions'
import { updateStreetViewCenter } from '../../store/Actions/MapActions'
import {
  cycloramaUsername,
  cycloramaPassword,
  cycloramaApiKey,
  cycloramaSrs,
  cycloramaLanguage,
} from '../../config'
import './styles/cyclorama.css'

class CycloramaInstance extends PureComponent {
  componentDidMount = () => {
    this.initApi(() => {
      this.openimage(this.props.center)
    })
  }

  initApi = _callback => {
    window.StreetSmartApi.init({
      targetElement: document.getElementById('cyclorama-container'),
      username: cycloramaUsername,
      password: cycloramaPassword,
      apiKey: cycloramaApiKey,
      srs: cycloramaSrs,
      locale: cycloramaLanguage,
    }).then(() => {
      _callback()
    })
  }

  cycloramaLoaded = () => {
    this.props.cycloramaLoading(false)
  }

  updateSteetviewMarkerCenter = () => {
    const view = window.panoramaViewer.getRecording()
    if (view !== null) {
      this.props.updateStreetViewCenter({
        lat: view.xyz[1],
        lng: view.xyz[0],
      })
    }
  }

  openimage = (xycoord, wkid) => {
    const viewerType = [window.StreetSmartApi.ViewerType.PANORAMA]
    window.StreetSmartApi.open(xycoord, {
      viewerType,
      srs: cycloramaSrs,
      maximizable: false,
      closable: false,
    })
      .then(result => {
        if (result && result[0]) {
          window.panoramaViewer = result[0]
          window.panoramaViewer.on(
            window.StreetSmartApi.Events.panoramaViewer.VIEW_LOAD_END,
            this.cycloramaLoaded
          )
          window.panoramaViewer.on(
            window.StreetSmartApi.Events.panoramaViewer.RECORDING_CLICK,
            this.updateSteetviewMarkerCenter
          )
          window.panoramaViewer.toggleNavbarVisible(false)
          window.panoramaViewer.toggleNavbarExpanded(false)
          window.panoramaViewer.toggleTimeTravelVisible(false)
          window.panoramaViewer.toggleTimeTravelExpanded(false)
        }
      })
      .catch(reason => {
        console.log(`Failed to create component(s) through API: ${reason}`)
      })
  }

  componentWillUnmount = () => {
    window.StreetSmartApi.destroy({
      targetElement: document.getElementById('cyclorama-container'),
    })
  }
  render() {
    return (
      <Fragment>
        <div id="cyclorama-container" />
        <CloseCyclorama />
      </Fragment>
    )
  }
}

CycloramaInstance.propTypes = {
  center: string.isRequired,
  cycloramaLoading: func.isRequired,
  updateStreetViewCenter: func.isRequired,
}

const mapStateToProps = ({ map }) => ({
  center: map.center.join(','),
})

const mapDispatchToProps = dispatch => ({
  cycloramaLoading: value => dispatch(cycloramaLoading(value)),
  updateStreetViewCenter: value => dispatch(updateStreetViewCenter(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CycloramaInstance)



// WEBPACK FOOTER //
// ./src/components/Cyclomedia/CycloramaInstance.jsx